<template>
    <div
    :class="[
        'show-cover',
        {
            'has-border': hasBorder,
            'has-image': show.cover.imageUrl,
            'is-invalid': !show.isValid,
            [`is-size-${size}`]: !!size,
            [borderColor]: hasBorder,
        }
    ]"
    >
        <img
            v-if="show.cover.imageUrl && show.isValid"
            :src="show.cover.imageUrl"
            :class="[{ 'image-error': hasImageError }]"
            @error="imageLoadError"
        >
    </div>
</template>

<script>
export default {
    props: {
        show: {
            type: Object,
            default: () => ({}),
        },
        hasBorder: {
            type: Boolean,
            default: false,
        },
        borderColor: {
            type: String,
            default: null,
        },
        size: {
            type: String,
            default: null,
        },
    },

    data: () => ({
        hasImageError: false,
    }),

    methods: {
        /**
         * Handles image src error
         *
         */
        imageLoadError() {
            this.hasImageError = true;
        },
    },
};
</script>
